/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FilterHistoryPayload model module.
 * @module model/FilterHistoryPayload
 * @version 1.0.0
 */
class FilterHistoryPayload {
    /**
     * Constructs a new <code>FilterHistoryPayload</code>.
     * @alias module:model/FilterHistoryPayload
     */
    constructor() { 
        
        FilterHistoryPayload.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FilterHistoryPayload</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FilterHistoryPayload} obj Optional instance to populate.
     * @return {module:model/FilterHistoryPayload} The populated <code>FilterHistoryPayload</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FilterHistoryPayload();

            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
            if (data.hasOwnProperty('score')) {
                obj['score'] = ApiClient.convertToType(data['score'], ['Number']);
            }
            if (data.hasOwnProperty('minAge')) {
                obj['minAge'] = ApiClient.convertToType(data['minAge'], 'Number');
            }
            if (data.hasOwnProperty('maxAge')) {
                obj['maxAge'] = ApiClient.convertToType(data['maxAge'], 'Number');
            }
            if (data.hasOwnProperty('minIncome')) {
                obj['minIncome'] = ApiClient.convertToType(data['minIncome'], 'Number');
            }
            if (data.hasOwnProperty('maxIncome')) {
                obj['maxIncome'] = ApiClient.convertToType(data['maxIncome'], 'Number');
            }
            if (data.hasOwnProperty('lengthOfService')) {
                obj['lengthOfService'] = ApiClient.convertToType(data['lengthOfService'], 'Number');
            }
            if (data.hasOwnProperty('useEstimatedLengthOfService')) {
                obj['useEstimatedLengthOfService'] = ApiClient.convertToType(data['useEstimatedLengthOfService'], 'Boolean');
            }
            if (data.hasOwnProperty('interestList')) {
                obj['interestList'] = ApiClient.convertToType(data['interestList'], ['Number']);
            }
            if (data.hasOwnProperty('occupationList')) {
                obj['occupationList'] = ApiClient.convertToType(data['occupationList'], ['Number']);
            }
            if (data.hasOwnProperty('financialAsset')) {
                obj['financialAsset'] = ApiClient.convertToType(data['financialAsset'], ['Number']);
            }
            if (data.hasOwnProperty('minHoldingPropertyCount')) {
                obj['minHoldingPropertyCount'] = ApiClient.convertToType(data['minHoldingPropertyCount'], 'Number');
            }
            if (data.hasOwnProperty('maxHoldingPropertyCount')) {
                obj['maxHoldingPropertyCount'] = ApiClient.convertToType(data['maxHoldingPropertyCount'], 'Number');
            }
            if (data.hasOwnProperty('days_since_proposal')) {
                obj['days_since_proposal'] = ApiClient.convertToType(data['days_since_proposal'], ['Number']);
            }
            if (data.hasOwnProperty('re_proposal_count')) {
                obj['re_proposal_count'] = ApiClient.convertToType(data['re_proposal_count'], ['Number']);
            }
            if (data.hasOwnProperty('has_other_information')) {
                obj['has_other_information'] = ApiClient.convertToType(data['has_other_information'], 'Boolean');
            }
            if (data.hasOwnProperty('address_prefectures')) {
                obj['address_prefectures'] = ApiClient.convertToType(data['address_prefectures'], ['String']);
            }
            if (data.hasOwnProperty('industryList')) {
                obj['industryList'] = ApiClient.convertToType(data['industryList'], ['Number']);
            }
            if (data.hasOwnProperty('addressOrStation')) {
                obj['addressOrStation'] = ApiClient.convertToType(data['addressOrStation'], 'String');
            }
            if (data.hasOwnProperty('prefectures')) {
                obj['prefectures'] = ApiClient.convertToType(data['prefectures'], ['String']);
            }
            if (data.hasOwnProperty('cities')) {
                obj['cities'] = ApiClient.convertToType(data['cities'], ['String']);
            }
            if (data.hasOwnProperty('minBuiltAt')) {
                obj['minBuiltAt'] = ApiClient.convertToType(data['minBuiltAt'], 'String');
            }
            if (data.hasOwnProperty('maxBuiltAt')) {
                obj['maxBuiltAt'] = ApiClient.convertToType(data['maxBuiltAt'], 'String');
            }
            if (data.hasOwnProperty('minRentIncome')) {
                obj['minRentIncome'] = ApiClient.convertToType(data['minRentIncome'], 'Number');
            }
            if (data.hasOwnProperty('maxRentIncome')) {
                obj['maxRentIncome'] = ApiClient.convertToType(data['maxRentIncome'], 'Number');
            }
            if (data.hasOwnProperty('managementType')) {
                obj['managementType'] = ApiClient.convertToType(data['managementType'], 'String');
            }
            if (data.hasOwnProperty('minOccupiedArea')) {
                obj['minOccupiedArea'] = ApiClient.convertToType(data['minOccupiedArea'], 'Number');
            }
            if (data.hasOwnProperty('maxOccupiedArea')) {
                obj['maxOccupiedArea'] = ApiClient.convertToType(data['maxOccupiedArea'], 'Number');
            }
            if (data.hasOwnProperty('walk')) {
                obj['walk'] = ApiClient.convertToType(data['walk'], 'Number');
            }
            if (data.hasOwnProperty('yearsPassedFromBoughtAt')) {
                obj['yearsPassedFromBoughtAt'] = ApiClient.convertToType(data['yearsPassedFromBoughtAt'], 'Number');
            }
            if (data.hasOwnProperty('propertyCategory')) {
                obj['propertyCategory'] = ApiClient.convertToType(data['propertyCategory'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FilterHistoryPayload</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FilterHistoryPayload</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['userId'] && !(typeof data['userId'] === 'string' || data['userId'] instanceof String)) {
            throw new Error("Expected the field `userId` to be a primitive type in the JSON string but got " + data['userId']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['score'])) {
            throw new Error("Expected the field `score` to be an array in the JSON data but got " + data['score']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['interestList'])) {
            throw new Error("Expected the field `interestList` to be an array in the JSON data but got " + data['interestList']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['occupationList'])) {
            throw new Error("Expected the field `occupationList` to be an array in the JSON data but got " + data['occupationList']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['financialAsset'])) {
            throw new Error("Expected the field `financialAsset` to be an array in the JSON data but got " + data['financialAsset']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['days_since_proposal'])) {
            throw new Error("Expected the field `days_since_proposal` to be an array in the JSON data but got " + data['days_since_proposal']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['re_proposal_count'])) {
            throw new Error("Expected the field `re_proposal_count` to be an array in the JSON data but got " + data['re_proposal_count']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['address_prefectures'])) {
            throw new Error("Expected the field `address_prefectures` to be an array in the JSON data but got " + data['address_prefectures']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['industryList'])) {
            throw new Error("Expected the field `industryList` to be an array in the JSON data but got " + data['industryList']);
        }
        // ensure the json data is a string
        if (data['addressOrStation'] && !(typeof data['addressOrStation'] === 'string' || data['addressOrStation'] instanceof String)) {
            throw new Error("Expected the field `addressOrStation` to be a primitive type in the JSON string but got " + data['addressOrStation']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['prefectures'])) {
            throw new Error("Expected the field `prefectures` to be an array in the JSON data but got " + data['prefectures']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['cities'])) {
            throw new Error("Expected the field `cities` to be an array in the JSON data but got " + data['cities']);
        }
        // ensure the json data is a string
        if (data['minBuiltAt'] && !(typeof data['minBuiltAt'] === 'string' || data['minBuiltAt'] instanceof String)) {
            throw new Error("Expected the field `minBuiltAt` to be a primitive type in the JSON string but got " + data['minBuiltAt']);
        }
        // ensure the json data is a string
        if (data['maxBuiltAt'] && !(typeof data['maxBuiltAt'] === 'string' || data['maxBuiltAt'] instanceof String)) {
            throw new Error("Expected the field `maxBuiltAt` to be a primitive type in the JSON string but got " + data['maxBuiltAt']);
        }
        // ensure the json data is a string
        if (data['managementType'] && !(typeof data['managementType'] === 'string' || data['managementType'] instanceof String)) {
            throw new Error("Expected the field `managementType` to be a primitive type in the JSON string but got " + data['managementType']);
        }
        // ensure the json data is a string
        if (data['propertyCategory'] && !(typeof data['propertyCategory'] === 'string' || data['propertyCategory'] instanceof String)) {
            throw new Error("Expected the field `propertyCategory` to be a primitive type in the JSON string but got " + data['propertyCategory']);
        }

        return true;
    }


}



/**
 * @member {String} userId
 */
FilterHistoryPayload.prototype['userId'] = undefined;

/**
 * @member {Array.<Number>} score
 */
FilterHistoryPayload.prototype['score'] = undefined;

/**
 * @member {Number} minAge
 */
FilterHistoryPayload.prototype['minAge'] = undefined;

/**
 * @member {Number} maxAge
 */
FilterHistoryPayload.prototype['maxAge'] = undefined;

/**
 * @member {Number} minIncome
 */
FilterHistoryPayload.prototype['minIncome'] = undefined;

/**
 * @member {Number} maxIncome
 */
FilterHistoryPayload.prototype['maxIncome'] = undefined;

/**
 * @member {Number} lengthOfService
 */
FilterHistoryPayload.prototype['lengthOfService'] = undefined;

/**
 * @member {Boolean} useEstimatedLengthOfService
 */
FilterHistoryPayload.prototype['useEstimatedLengthOfService'] = undefined;

/**
 * @member {Array.<Number>} interestList
 */
FilterHistoryPayload.prototype['interestList'] = undefined;

/**
 * @member {Array.<Number>} occupationList
 */
FilterHistoryPayload.prototype['occupationList'] = undefined;

/**
 * @member {Array.<Number>} financialAsset
 */
FilterHistoryPayload.prototype['financialAsset'] = undefined;

/**
 * @member {Number} minHoldingPropertyCount
 */
FilterHistoryPayload.prototype['minHoldingPropertyCount'] = undefined;

/**
 * @member {Number} maxHoldingPropertyCount
 */
FilterHistoryPayload.prototype['maxHoldingPropertyCount'] = undefined;

/**
 * @member {Array.<Number>} days_since_proposal
 */
FilterHistoryPayload.prototype['days_since_proposal'] = undefined;

/**
 * @member {Array.<Number>} re_proposal_count
 */
FilterHistoryPayload.prototype['re_proposal_count'] = undefined;

/**
 * @member {Boolean} has_other_information
 */
FilterHistoryPayload.prototype['has_other_information'] = undefined;

/**
 * @member {Array.<String>} address_prefectures
 */
FilterHistoryPayload.prototype['address_prefectures'] = undefined;

/**
 * @member {Array.<Number>} industryList
 */
FilterHistoryPayload.prototype['industryList'] = undefined;

/**
 * @member {String} addressOrStation
 */
FilterHistoryPayload.prototype['addressOrStation'] = undefined;

/**
 * @member {Array.<String>} prefectures
 */
FilterHistoryPayload.prototype['prefectures'] = undefined;

/**
 * @member {Array.<String>} cities
 */
FilterHistoryPayload.prototype['cities'] = undefined;

/**
 * @member {String} minBuiltAt
 */
FilterHistoryPayload.prototype['minBuiltAt'] = undefined;

/**
 * @member {String} maxBuiltAt
 */
FilterHistoryPayload.prototype['maxBuiltAt'] = undefined;

/**
 * @member {Number} minRentIncome
 */
FilterHistoryPayload.prototype['minRentIncome'] = undefined;

/**
 * @member {Number} maxRentIncome
 */
FilterHistoryPayload.prototype['maxRentIncome'] = undefined;

/**
 * @member {String} managementType
 */
FilterHistoryPayload.prototype['managementType'] = undefined;

/**
 * @member {Number} minOccupiedArea
 */
FilterHistoryPayload.prototype['minOccupiedArea'] = undefined;

/**
 * @member {Number} maxOccupiedArea
 */
FilterHistoryPayload.prototype['maxOccupiedArea'] = undefined;

/**
 * @member {Number} walk
 */
FilterHistoryPayload.prototype['walk'] = undefined;

/**
 * @member {Number} yearsPassedFromBoughtAt
 */
FilterHistoryPayload.prototype['yearsPassedFromBoughtAt'] = undefined;

/**
 * @member {String} propertyCategory
 */
FilterHistoryPayload.prototype['propertyCategory'] = undefined;






export default FilterHistoryPayload;

